import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';

import { Observable } from 'rxjs';
import { Pos } from 'src/app/core/classes/pos';
import { PosService } from 'src/app/core/services/pos.service';
import {
  NgbdSortableHeader,
  SortEvent,
} from 'src/app/directives/sortable/sortable.directive';

@Component({
  selector: 'dq-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit {
  pos$!: Observable<Pos[]>;
  pos: Pos[] = [];
  posPaginated: Pos[] = [];

  total: number = 0;
  page = 1;
  pageSize = 10;

  @ViewChildren(NgbdSortableHeader) headers:
    | QueryList<NgbdSortableHeader>
    | undefined;

  constructor(private posService: PosService) {}

  ngOnInit() {
    this.pos$ = this.posService.posFiltered$;
    this.pos$.subscribe((pos: Pos[]) => {
      this.posPaginated = pos.slice(
        (this.page - 1) * this.pageSize,
        (this.page - 1) * this.pageSize + this.pageSize
      );
      this.pos = pos;
      this.total = pos.length;
    });
  }

  onSort({ column, direction }: SortEvent) {
    if (this.headers) {
      this.headers.forEach((header) => {
        if (header.sortable !== column) {
          header.direction = '';
        }
      });

      this.posService.sortColumn = column;
      this.posService.sortDirection = direction;
    }
  }

  refreshPos() {
    this.posPaginated = this.pos.slice(
      (this.page - 1) * this.pageSize,
      (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  hasAddress(pos: Pos): boolean {
    let has = true;
    if (pos != null && pos != undefined) {
      has = has && pos.shippingStreet != null && pos.shippingStreet != '';
      has = has && pos.shippingCity != null && pos.shippingCity != '';
      has =
        has && pos.shippingPostalCode != null && pos.shippingPostalCode != '';
      has = has && pos.shippingState != null && pos.shippingState != '';
      has = has && pos.shippingCountry != null && pos.shippingCountry != '';
    }
    return has;
  }

  fullAdrress(pos: Pos): string {
    let str = '-';

    if (pos != null && pos != undefined) {
      str = '';
      str = str + (pos.shippingStreet ? pos.shippingStreet : '');
      str = str + (pos.shippingCity ? ', ' + pos.shippingCity : '');
      str =
        str +
        ', ' +
        (pos.shippingPostalCode ? '(' + pos.shippingPostalCode + ')' : '');
      str = str + (pos.shippingState ? ', ' + pos.shippingState : ' ');
      str = str + (pos.shippingCountry ? ', ' + pos.shippingCountry : ' ');
    }
    return str;
  }
}
